import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { TituloReceberPerspectivaSelectComponent } from './titulo-receber-perspectiva-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TituloReceberPerspectivaSelectComponent
    ],
    exports: [
        TituloReceberPerspectivaSelectComponent
    ]
})
export class TituloReceberPerspectivaSelectModule { }
